import { catalogs, registerCatalog } from "./localization";
import type { Language } from "./languages";

const loaders = {
  es: () => import("../locales/es.json"), fr: () => import("../locales/fr.json"),
  de: () => import("../locales/de.json"), pt: () => import("../locales/pt.json"),
  ja: () => import("../locales/ja.json"), ko: () => import("../locales/ko.json"),
  ar: () => import("../locales/ar.json"), hi: () => import("../locales/hi.json"),
};
const pending = new Map<Language, Promise<void>>();
export const loadLanguage = (language: Language): Promise<void> => {
  if (catalogs[language]) return Promise.resolve();
  if (pending.has(language)) return pending.get(language)!;
  const operation = (async () => {
    let timer: ReturnType<typeof setTimeout> | undefined;
    try {
      const module = await Promise.race([
        loaders[language as keyof typeof loaders](),
        new Promise<never>((_, reject) => { timer = setTimeout(() => reject(new Error("language_load_timeout")), 15_000); }),
      ]);
      registerCatalog(language, module.default);
    } finally { clearTimeout(timer); }
  })();
  pending.set(language, operation);
  void operation.finally(() => pending.delete(language)).catch(() => undefined);
  return operation;
};
